import { registerPlugin } from '@capacitor/core';
import type { LynxLocationPlugin } from './locationDefinitions';
import { getSimPhoneHost } from './simPhone';

const simHost = getSimPhoneHost();

/** Typed Capacitor bridge for LynxLocation (GPS — future D3 Swift plugin; unused in P1). On a sim phone, simLocation.ts. */
export const LynxLocation = registerPlugin<LynxLocationPlugin>(
  'LynxLocation',
  simHost
    ? { web: () => import('./simLocation').then((m) => new m.SimLocationPlugin(simHost)) }
    : {},
);
